export const canUploadAttachments = (): boolean => {
  const role = localStorage.getItem('user_role')?.toUpperCase();
  return role === 'ADMIN' || role === 'ACCOUNTANT';
};

/** Draft parent: ADMIN + ACCOUNTANT. Posted/received parent: ADMIN only. */
export const canDeleteAttachment = (parentIsDraft: boolean): boolean => {
  const role = localStorage.getItem('user_role')?.toUpperCase();
  if (parentIsDraft) {
    return role === 'ADMIN' || role === 'ACCOUNTANT';
  }
  return role === 'ADMIN';
};

export const canEditAttachmentMetadata = (): boolean => canUploadAttachments();
